import api from "../http";

export default class ApiSeo {
  static async getApiSeo(url, page) {
    const params = {
      page: page
    };
    return api.get(url, {params})
  }
}